var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgB2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 35,
    viewBox: "0 0 90 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.739316 15.854C-0.992745 4.88604 5.38463 3.83029 17.1866 1.96652C28.9886 0.102759 86.395 -1.50319 89.4406 8.7906C91.1727 19.7586 37.1926 32.366 25.3906 34.2298C13.5886 36.0936 2.47138 26.8221 0.739316 15.854Z",
    fill: "#A2EDFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgB2);
export default __webpack_public_path__ + "static/media/b2.3ba18c7cc192249f17b2d55761607871.svg";
export { ForwardRef as ReactComponent };